// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__didg0","header":"header_header__A7NEZ","app_name":"header_app_name__gq6x8","logo":"header_logo__TmkQW"};